import Profile from "../../pages/user/profile/Profile";

export default function ProfileView() {
  return <Profile />
}